import { render } from "./LearningHubCourses.vue?vue&type=template&id=5e0dadd5"
import script from "./LearningHubCourses.vue?vue&type=script&lang=js"
export * from "./LearningHubCourses.vue?vue&type=script&lang=js"

import "./LearningHubCourses.vue?vue&type=style&index=0&id=5e0dadd5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__